<template>
  <div>
    <div class="uploader-photo" v-if="formItem.field['dsfa_mm.controls'].value === 'dsf.uploadphoto' && formItem.field_property_value !== '0'">
      <el-upload
        style="text-align: center; line-height: 10px"
        class="avatar-uploader"
        :action="'/file/upload/'"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :multiple="false"
        :before-upload="beforeAvatarUpload"
      >
        <div v-if="imageUrl" class="user-photo-cont">
          <img :src="imageUrl" class="avatar" />
          <div class="delete-img">
            <i class="iconfont icon-shanchu" @click.capture="handleRemove"></i>
          </div>
        </div>
        <div v-else class="user-photo-cont">
          <i class="el-icon-plus">{{ formItem.fields_text }}上传</i>
        </div>
      </el-upload>
    </div>

    <el-form-item
      :label="formItem.fields_text"
      :prop="formItem.fields_value"
      v-if="formItem.field['dsfa_mm.controls'].value === 'dsf.textbox' && formItem.field_property_value !== '0'"
      :rules="rules"
    >
      <el-input
        v-model="modelvalueCopy"
        :class="{
          'user-input-short': isShort,
        }"
        @blur="$emit('set-value', formItem.fields_value, modelvalueCopy)"
      ></el-input>
    </el-form-item>

    <el-form-item
      :label="formItem.fields_text"
      :prop="formItem.fields_value"
      v-if="formItem.field['dsfa_mm.controls'].value === 'dsf.datepicker' && formItem.field_property_value !== '0'"
      :rules="rules"
    >
      <el-date-picker
        :class="{
          'user-input-short': isShort,
        }"
        type="date"
        format="yyyy 年 MM 月 dd 日"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd"
        v-model="currentDate"
        style="width: 100%"
        @change="$emit('set-value', formItem.fields_value, currentDate)"
      ></el-date-picker>
    </el-form-item>

    <el-form-item
      :label="formItem.fields_text"
      :prop="formItem.fields_value"
      v-if="formItem.field['dsfa_mm.controls'].value === 'dsf.radiobox' && formItem.fields_value === 'sex' && formItem.field_property_value !== '0'"
      :rules="rules"
    >
      <el-radio-group
        :class="{
          'user-input-short': isShort,
        }"
        v-model="radioValue"
        @change="changeSex"
      >
        <el-radio v-for="item in radioOption" :key="item.text" :label="item">{{ item.text }}</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item
      :label="formItem.fields_text"
      :prop="formItem.fields_value"
      v-if="formItem.field['dsfa_mm.controls'].value === 'dsf.select' && formItem.field_property_value !== '0'"
      :rules="rules"
    >
      <el-select
        :class="{
          'user-input-short': isShort,
        }"
        v-model="modelvalueCopy"
        placeholder="请选择"
      >
        <el-option label="option1" value="option1"></el-option>
        <el-option label="option2" value="option2"></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "UserFormItem",
  props: {
    modelvalue: {},
    rules: {
      type: Array,
    },

    formItem: {
      type: Object,
    },
    itemIndex: {
      type: Number,
    },
    hasphoto: {
      type: Boolean,
      default: false,
    },
    sexSetting: {
      type: Array,
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      currentDate: "",
      headhost: "",
      imageUrl: "",
      radioValue: "",
      modelvalueCopy: "",
      radioOption: [],
      isShort: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.modelvalueCopy = this.modelvalue;
      if (this.hasphoto) {
        if (this.itemIndex == 1 || this.itemIndex == 2) {
          this.isShort = true;
        }
      }

      if (this.formItem.field["dsfa_mm.controls"].value === "dsf.radiobox") {
        if (this.formItem.field["dsfa_mm.dataSource"]) {
          var id = JSON.parse(this.formItem.field["dsfa_mm.dataSource"]).code;
          var loading = dsf.layer.loading();
          this.$http
            .get("/examUser/entrance/getDict/" + id, {}, $$webRoot.exam)
            .done((res) => {
              if (res.success) {
                //查询成功
                var data = res.data;
                this.radioOption = data.map((item) => {
                  return { text: item.text, value: item.value };
                });
              } else {
                dsf.layer.message(res.message || "请求异常", false);
              }
            })
            .error((err) => {
              dsf.layer.message((err && err.message) || "请求异常", false);
            })
            .always(() => {
              dsf.layer.closeLoading(loading);
            });
        }
      }
    });
  },
  methods: {
    changeSex(val) {
      this.$emit("set-value", this.formItem.fields_value + "_value", val.value);
      this.$emit("set-value", this.formItem.fields_value + "_text", val.text);
      this.$emit("set-value", this.formItem.fields_value, val);
    },
    //删除头像
    handleRemove(e) {
      e.stopPropagation(); //阻止冒泡事件
      this.imageUrl = "";
      //   this.form.photo = null;
      this.$emit("set-value", "photo", null);
    },
    //头像上传成功
    handleAvatarSuccess(response, file, fileList) {
      //   this.form.photo = response.data;
      this.$emit("set-value", "photo", response.data);
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    //图片上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        dsf.layer.message("上传头像图片只能是 JPG 或 PNG 格式!", false);
      }
      if (!isLt2M) {
        dsf.layer.message("上传头像图片大小不能超过 2MB!", false);
      }
      return isJPG && isLt2M;
    },
  },
  watch: {
    modelvalue(val) {
      // console.log(val);
      if (this.formItem.field["dsfa_mm.controls"].value === "dsf.uploadphoto" && val?.length == 0) {
        this.imageUrl = "";
      } else {
        this.modelvalueCopy = val;
        this.radioValue = val;
      }
    },
  },
};
</script>

<style></style>
